const nogpscols = [
    { field: "GPSID" },
    { field: "latitude" },
    { field: "longitude", minWidth: 150 }
];
export {nogpscols};